<div class="listview container-fluid">
  <div class="row">
    <div [class]="canAdminInquiry ? 'col-xxl-8' : 'col-xxl-12'">
      <button
        type="button"
        class="btn btn-primary btn-full-width mb-4 align-item-center"
        (click)="openNewStaffRequestModal()"
      >
        <i class="fa-solid fa-plus headline-20 me-2"></i>
        <span class="headline-20">{{ 'inquiry.new' | translate }}</span>
      </button>
      <base-customer-dashboard-operations
        [active]="dashboardData?.assignments?.active"
        [planned]="dashboardData?.assignments?.planned"
        [isButtonVisible]="canAdminAssignments"
      ></base-customer-dashboard-operations>
      <div class="teaser">
        <base-dashboard-card-header
          header="dashboardInfo.missedCustomerSpecifications"
          [amount]="dashboardData?.unsignedContracts?.cust + dashboardData?.unsignedContracts?.psp"
          buttonLabel="action.showMore"
          [isButtonAllowed]="canAdminAssignments"
          [showBorder]="false"
          link="external-employees/list"
          [queryParams]="{ openContract: 'customer,psp', status: 'active,planned' }"
        ></base-dashboard-card-header>
      </div>
      <div class="teaser">
        <base-dashboard-card-header
          [amount]="dashboardData?.inquiries?.unpublished"
          header="dashboardInfo.notPublishedInquiries"
          [showBorder]="false"
          [isButtonAllowed]="canAdminInquiry"
          buttonLabel="action.showMore"
          link="inquiries/list"
          [queryParams]="{ status: '1' }"
        ></base-dashboard-card-header>
        <base-customer-dashboard-unpublished-inquiries
          *ngIf="unpublishedInquiries?.length"
          [unpublishedInquiries]="unpublishedInquiries"
        ></base-customer-dashboard-unpublished-inquiries>
      </div>
    </div>

    <div
      class="col-xxl-4 d-flex flex-column"
      *ngIf="canAdminInquiry"
    >
      <div class="teaser">
        <base-dashboard-card-header
          header="dashboardInfo.newOffers"
          [showBorder]="false"
          icon="fa-arrows-rotate"
          (buttonClick)="onOfferRefresh()"
        ></base-dashboard-card-header>
      </div>
      <div class="row">
        <div
          class="col-lg-6 col-xxl-12"
          *ngFor="let offer of customerOffers; let i = index"
        >
          <base-customer-dashboard-offer-card
            [isRecent]="!i"
            [offer]="offer"
            [routerLink]="
              offer.unlimited
                ? '/inquiries/' + offer.inquiry.id + '/unlimited/offers'
                : '/inquiries/' + offer.inquiry.id + '/offers'
            "
          ></base-customer-dashboard-offer-card>
        </div>
        <base-empty-list-row
          message="dashboardInfo.noOffers"
          [largeImage]="true"
          *ngIf="!customerOffers?.length"
        ></base-empty-list-row>
      </div>
    </div>
  </div>
</div>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [isInquiryDefaultFilter]="true"
    [modalRef]="modalRef"
  ></base-customer-staff-request-modal>
</ng-template>
